var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSentTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0098 14.1006C35.6917 14.7823 35.694 15.8897 35.0148 16.5741L20.332 31.3715C19.6529 32.0559 18.5496 32.0582 17.8677 31.3766L12.5129 26.0242C11.831 25.3425 11.8287 24.2351 12.5078 23.5507C13.1869 22.8662 14.2902 22.8639 14.9722 23.5455L19.0923 27.6638L32.5455 14.1056C33.2246 13.4212 34.3279 13.4189 35.0098 14.1006Z",
    fill: "#50B83C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 3.49188C14.2452 3.49188 6.48112 9.95424 4.48811 18.6114L4.4881 18.6114C4.16367 20.0206 3.99188 21.4894 3.99188 23C3.99188 33.7659 12.7341 42.5081 23.5 42.5081C34.2659 42.5081 43.0081 33.7659 43.0081 23C43.0081 12.2341 34.2659 3.49188 23.5 3.49188ZM1.08524 17.828C3.43482 7.62201 12.5815 0 23.5 0C36.1944 0 46.5 10.3056 46.5 23C46.5 35.6944 36.1944 46 23.5 46C10.8056 46 0.5 35.6944 0.5 23C0.5 21.2238 0.702092 19.4922 1.08524 17.828Z",
    fill: "#50B83C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentTickIcon);
export default __webpack_public_path__ + "static/media/emailSentTick-icon.b52dbb6d92a8e066ba63dd9f8b1fe3a6.svg";
export { ForwardRef as ReactComponent };